import { useEffect } from 'react';

/**
 * Ferme un élément flottant (menu déroulant, popover…) lorsqu'on clique en
 * dehors de son conteneur ou qu'on appuie sur Échap.
 * Générique : utilisé par ShopSwitcher et UserMenu.
 * @param {React.RefObject<HTMLElement>} ref - Conteneur incluant déclencheur et contenu
 * @param {boolean} estOuvert - N'écoute les événements que lorsque l'élément est ouvert
 * @param {Function} fermer - Callback de fermeture
 */
const useFermetureExterieure = (ref, estOuvert, fermer) => {
  useEffect(() => {
    if (!estOuvert) return undefined;

    const fermerSiExterieur = (event) => {
      if (ref.current && !ref.current.contains(event.target)) fermer();
    };
    const fermerSurEchap = (event) => {
      if (event.key === 'Escape') fermer();
    };

    document.addEventListener('mousedown', fermerSiExterieur);
    document.addEventListener('keydown', fermerSurEchap);
    return () => {
      document.removeEventListener('mousedown', fermerSiExterieur);
      document.removeEventListener('keydown', fermerSurEchap);
    };
  }, [ref, estOuvert, fermer]);
};

export default useFermetureExterieure;
